import { render, staticRenderFns } from "./ThreeaseLogo.vue?vue&type=template&id=bb449dec&"
import script from "./ThreeaseLogo.vue?vue&type=script&lang=ts&"
export * from "./ThreeaseLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports